/**
 * Ansprechpartner: Anzeigename und Briefanrede.
 *
 * Ein Beleg traegt den gewaehlten Ansprechpartner als Kopie
 * (ContactSnapshot) - wird die Person spaeter umbenannt oder geloescht,
 * bleibt der alte Beleg, wie er verschickt wurde.
 */
/** "Herr Dr. Peter Krüger" - fuer Listen und die z.-Hd.-Zeile. */
export function contactDisplayName(contact) {
    return [contact.salutation, contact.firstName, contact.lastName]
        .filter((part) => Boolean(part && part.trim()))
        .join(' ');
}
/**
 * Briefanrede fuer Beleg und E-Mail.
 *
 * Die Beugung haengt an der Anredeform: "Herr..." wird zu "Sehr geehrter
 * Herr X", "Frau..." zu "Sehr geehrte Frau X". Bei anderer oder fehlender
 * Anredeform weicht der Text auf das neutrale "Guten Tag" aus - lieber
 * schlicht als falsch gebeugt. Ohne Ansprechpartner bleibt es bei
 * "Sehr geehrte Damen und Herren".
 */
export function contactGreeting(contact) {
    if (!contact)
        return 'Sehr geehrte Damen und Herren,';
    const salutation = contact.salutation?.trim() ?? '';
    if (salutation.startsWith('Herr')) {
        return `Sehr geehrter ${salutation} ${contact.lastName},`;
    }
    if (salutation.startsWith('Frau')) {
        return `Sehr geehrte ${salutation} ${contact.lastName},`;
    }
    return `Guten Tag ${contactDisplayName(contact)},`;
}
//# sourceMappingURL=contacts.js.map